

<div *ngIf="!isLoading && FaultsGridData.length > 0">
	<div class="panel panel-default">
		<div class="panel-heading">
			<h4 class="panel-title">PolarLink Faults</h4>
		</div>
		<div class="panel-body">
			<app-grid-v2 #faultsGrid
				translateHeaders="true"
				id="PlinkFaultsGrid"
				[modelId]="plink.deviceid"
				[columns]="FaultsGridColumns"
				[data]="FaultsGridData"
				[settings]="settings"
				(onCellClicked)="onFaultCellClicked($event)"
			></app-grid-v2>
		</div>
	</div>
</div>

<div *ngIf="!isLoading && FaultsGridData.length == 0">
	<div class="panel panel-default">
		<div class="panel-body">
			<strong>No PolarLink Faults Found!</strong>
		</div>
	</div>
</div>

<div *ngIf="!hasPlinks">
	<div class="panel panel-default">
		<div class="panel-body">
			<strong>No PolarLink Devices Found!</strong>
		</div>
	</div>
</div>
